import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=c179b036&scoped=true&"
import script from "./Paragraph.vue?vue&type=script&lang=ts&"
export * from "./Paragraph.vue?vue&type=script&lang=ts&"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=c179b036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c179b036",
  null
  
)

export default component.exports